<div>
  <app-body>
    Your employment has ended. This account will expire on&nbsp;
    <app-body bold>{{ expiryDate }}</app-body>
    .&nbsp;You will no longer be able to access your account after this date. Please download copies of your payslips etc. before your
    account expires.
  </app-body>
  <br />
</div>
